class BwBlogOverview extends HTMLElement {
  connectedCallback() {
    this.initial = parseInt(this.dataset.postsInitial, 10) || 6;
    this.perLoad = parseInt(this.dataset.postsPerLoad, 10) || 3;
    this.list = this.querySelector('[data-bw-blog-overview-list]');
    this.wrap = this.querySelector('[data-bw-blog-overview-loadmore-wrap]');
    this.button = this.wrap && this.wrap.querySelector('a, button');
    this.filters = Array.from(this.querySelectorAll('[data-bw-blog-overview-filter]'));

    if (!this.list) return;

    this.cards = Array.from(this.list.querySelectorAll('[data-bw-blog-overview-card]'));
    this.activeFilter = 'all';
    this.visibleLimit = this.initial;

    if (this.button) this.button.addEventListener('click', this.handleLoadMore.bind(this));
    this.filters.forEach((btn) => btn.addEventListener('click', this.handleFilter.bind(this)));
  }

  handleLoadMore(event) {
    event.preventDefault();
    this.visibleLimit += this.perLoad;
    this.render();
  }

  handleFilter(event) {
    const value = event.currentTarget.dataset.bwBlogOverviewFilter;
    if (value === this.activeFilter) return;
    this.activeFilter = value;
    this.visibleLimit = this.initial;
    this.filters.forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.dataset.bwBlogOverviewFilter === value));
    });
    this.render();
  }

  render() {
    let matchIndex = 0;
    this.cards.forEach((card) => {
      const matches = this.activeFilter === 'all' || card.dataset.bwBlogHandle === this.activeFilter;
      card.hidden = !(matches && matchIndex < this.visibleLimit);
      if (matches) matchIndex += 1;
    });
    if (this.wrap) this.wrap.hidden = matchIndex <= this.visibleLimit;
  }
}

if (!customElements.get('bw-blog-overview')) {
  customElements.define('bw-blog-overview', BwBlogOverview);
}
